// extracted by mini-css-extract-plugin
module.exports = {"CountsBox":"CountsBox_CountsBox__3VZmI","TopRow":"CountsBox_TopRow__3d7QX","BottomRow":"CountsBox_BottomRow__34yIu"};